// TODO: Create i10n for reason names
export const ReasonsForAbsence = Object.freeze([
  {
    id: 'Not Provided',
    name: 'Not Provided',
  },
  {
    id: 'Sick Leave Cover',
    name: 'Sick Leave Cover (Formerly Sickness)',
  },
  {
    id: 'Professional Development',
    name: 'Professional Development',
  },
  {
    id: 'Annual Leave Cover',
    name: 'Annual Leave Cover (Formerly Leave)',
  },
  {
    id: 'Break Cover',
    name: 'Break Cover',
  },
  {
    id: 'Vacant Position',
    name: 'Vacant Position',
  },
  {
    id: 'Training Cover',
    name: 'Training Cover',
  },
  {
    id: 'Government Funding',
    name: 'Government Funding',
  },
  {
    id: 'Rostered Day Off',
    name: 'Rostered Day Off',
  },
  {
    id: "Carer's Leave",
    name: "Carer's Leave",
  },
  {
    id: 'Long Service Leave',
    name: 'Long Service Leave',
  },
  {
    id: 'F&P Testing',
    name: 'F&P Testing',
  },
  {
    id: 'Professional Practice Day',
    name: 'Professional Practice Day',
  },
  {
    id: 'Other',
    name: 'Other',
  },
])
